import { z } from 'zod';

const uuid = z.string().uuid();
const amount = z.number().finite().nonnegative().nullable();
const date = z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine(
  value => !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value,
  'Data documento non valida',
);

export const posDdtOffersRequestSchema = z.object({
  product_id: uuid,
  variant_id: uuid.nullish(),
  supplier_ids: z.array(uuid).min(1).max(100),
  ddt_date: date,
  quantity: z.number().finite().positive(),
}).strict();
export type PosDdtOffersRequest = z.infer<typeof posDdtOffersRequestSchema>;

/** Canonical SdI and pre-discount monetary snapshot. No product/default VAT fallbacks. */
export const posDdtOfferSchema = z.object({
  price_list_id: uuid,
  price_list_item_id: uuid,
  supplier_id: uuid,
  supplier_name: z.string(),
  price_list_name: z.string(),
  price_list_version: z.number().int().positive(),
  product_id: uuid,
  variant_id: uuid.nullable(),
  product_name: z.string(),
  variant_attributes: z.record(z.string(), z.string()).nullable(),
  sku: z.string().nullable(),
  supplier_sku: z.string().nullable(),
  ean: z.string().nullable(),
  unit_price_net: amount,
  unit_price_gross: amount,
  unit_vat_amount: amount,
  discount_percent: z.number().finite().min(0).max(100),
  vat_rate_id: uuid.nullable(),
  vat_rate: z.number().finite().min(0).max(100).nullable(),
  vat_code: z.string().nullable(),
  vat_nature: z.string().nullable(),
  sdi_rif_id: z.number().int().nullable(),
  riferimento_normativo: z.string().nullable(),
  valid_from: date.nullable(),
  valid_to: date.nullable(),
  min_quantity: amount,
  max_quantity: amount,
  fingerprint: z.string().regex(/^[a-f0-9]{64}$/),
  usable: z.boolean(),
  unavailable_reason: z.string().nullable(),
}).strict();
export type PosDdtOffer = z.infer<typeof posDdtOfferSchema>;
export const posDdtOffersResponseSchema = z.object({ offers: z.array(posDdtOfferSchema) }).strict();
export type PosDdtOffersResponse = z.infer<typeof posDdtOffersResponseSchema>;